import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { IExistingLeaveSchema, ILeave, ILeaveDetailId, ILeaveSchema, ILeaveState } from './types';
const initialState: ILeaveState = {
  addLeave: {},
  leaves: {},
  updateLeaveStatus: {},
  updateLeave: {},
  leaveDetails: {},
  leaveDetailsSchema: {},
  sendLeave: {},
  sendToManager: {},
  getUsers: {},
  addExistingLeave: {},
};
const slice = createSlice({
  name: 'leaves',
  initialState,
  reducers: {
    addLeave(state, action: PayloadAction<ILeaveSchema>) {
      state.addLeave.status = RequestStatus.RUNNING;
    },
    addLeaveSuccess(state, action) {
      state.addLeave.status = RequestStatus.SUCCESS;
      state.addLeave.data = action.payload;
    },
    addLeaveFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addLeave.status = RequestStatus.ERROR;
      state.addLeave.error = action.payload;
    },
    //
    getLeaves(state, action: PayloadAction<boolean>) {
      state.leaves.status = RequestStatus.RUNNING;
    },
    getLeavesSuccess(state, action: PayloadAction<ILeaveState['leaves']['data']>) {
      state.leaves.status = RequestStatus.SUCCESS;
      state.leaves.data = action.payload;
    },
    getLeavesFailed(state, action: PayloadAction<IRequestFailed>) {
      state.leaves.status = RequestStatus.ERROR;
      state.leaves.error = action.payload;
    },
    //
    updateLeaveStatus(state, action: PayloadAction<ILeave>) {
      state.updateLeaveStatus.status = RequestStatus.RUNNING;
    },
    updateLeaveStatusSuccess(state, action: PayloadAction<ILeave>) {
      state.updateLeaveStatus.status = RequestStatus.SUCCESS;
      state.updateLeaveStatus.data = action.payload;
    },
    updateLeaveStatusFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateLeaveStatus.status = RequestStatus.ERROR;
      state.updateLeaveStatus.error = action.payload;
    },
    //
    sendToManager(state, action: PayloadAction<any>) {
      state.sendToManager.status = RequestStatus.RUNNING;
    },
    sendToManagerSuccess(state, action: PayloadAction<any>) {
      state.sendToManager.status = RequestStatus.SUCCESS;
      state.sendToManager.data = action.payload;
    },
    sendToManagerFailed(state, action: PayloadAction<IRequestFailed>) {
      state.sendToManager.status = RequestStatus.ERROR;
      state.sendToManager.error = action.payload;
    },
    //
    updateLeave(state, action: PayloadAction<ILeaveSchema>) {
      state.updateLeave.status = RequestStatus.RUNNING;
    },
    updateLeaveSuccess(state, action: PayloadAction<ILeave>) {
      state.updateLeave.status = RequestStatus.SUCCESS;
      state.updateLeave.data = action.payload;
    },
    updateLeaveFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateLeave.status = RequestStatus.ERROR;
      state.updateLeave.error = action.payload;
    },
    //
    getLeaveDetails(state, action: PayloadAction<ILeaveDetailId>) {
      state.leaveDetails.status = RequestStatus.RUNNING;
    },
    getLeaveDetailsSuccess(state, action: PayloadAction<ILeaveState['leaveDetails']['data']>) {
      state.leaveDetails.status = RequestStatus.SUCCESS;
      state.leaveDetails.data = action.payload;
    },
    getLeaveDetailsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.leaveDetails.status = RequestStatus.ERROR;
      state.leaveDetails.error = action.payload;
    },
    //
    sendLeave(state, action: PayloadAction<ILeaveSchema>) {
      state.sendLeave.status = RequestStatus.RUNNING;
    },
    sendLeaveSuccess(state, action) {
      state.sendLeave.status = RequestStatus.SUCCESS;
      state.addLeave.data = action.payload;
    },
    sendLeaveFailed(state, action: PayloadAction<IRequestFailed>) {
      state.sendLeave.status = RequestStatus.ERROR;
      state.sendLeave.error = action.payload;
    },
    //
    getUsers(state) {
      state.getUsers.status = RequestStatus.RUNNING;
    },
    getUsersSuccess(state, action) {
      state.getUsers.status = RequestStatus.SUCCESS;
      state.getUsers.data = action.payload;
    },
    getUsersFailed(state, action: PayloadAction<IRequestFailed>) {
      state.getUsers.status = RequestStatus.ERROR;
      state.getUsers.error = action.payload;
    },
    //
    addExistingLeave(state, action: PayloadAction<IExistingLeaveSchema>) {
      state.addExistingLeave.status = RequestStatus.RUNNING;
    },
    addExistingLeaveSuccess(state, action) {
      state.addExistingLeave.status = RequestStatus.SUCCESS;
      state.addExistingLeave.data = action.payload;
    },
    addExistingLeaveFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addExistingLeave.status = RequestStatus.ERROR;
      state.addExistingLeave.error = action.payload;
    },
  },
});

export default slice.reducer;
export const {
  addLeave,
  addLeaveSuccess,
  addLeaveFailed,
  getLeaves,
  getLeavesSuccess,
  getLeavesFailed,
  updateLeaveStatus,
  updateLeaveStatusSuccess,
  updateLeaveStatusFailed,
  updateLeave,
  updateLeaveFailed,
  updateLeaveSuccess,
  getLeaveDetails,
  getLeaveDetailsFailed,
  getLeaveDetailsSuccess,
  sendLeave,
  sendLeaveSuccess,
  sendLeaveFailed,
  sendToManager,
  sendToManagerFailed,
  sendToManagerSuccess,
  getUsers,
  getUsersFailed,
  getUsersSuccess,
  addExistingLeave,
  addExistingLeaveFailed,
  addExistingLeaveSuccess,
} = slice.actions;
